const CONFIGURABLE_CONSTANTS = {
  DFO_WR_MANAGER_ENV: process.env.DFO_WR_MANAGER_ENV,
  DFO_WR_MANAGER_SSO_BASE_URL: process.env.DFO_WR_MANAGER_SSO_BASE_URL,
  DFO_WR_MANAGER_SSO_APP_ID: process.env.DFO_WR_MANAGER_SSO_APP_ID,
  DFO_WR_MANAGER_SSO_API_URL: process.env.DFO_WR_MANAGER_SSO_API_URL,
  DFO_WR_MANAGER_BASE_URL: process.env.DFO_WR_MANAGER_BASE_URL
}

export default CONFIGURABLE_CONSTANTS
